import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api, { fmtRM } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    const poll = setInterval(async () => {
      tries++;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setStatus(r.data);
        if (r.data.payment_status === "paid" || tries > 12) clearInterval(poll);
      } catch {
        if (tries > 12) clearInterval(poll);
      }
    }, 2000);
    return () => clearInterval(poll);
  }, [sessionId]);

  const paid = status?.payment_status === "paid";

  return (
    <div className="min-h-screen bg-sand flex items-center justify-center p-6">
      <div className="bg-white border border-sand-border rounded-2xl p-10 max-w-md w-full text-center shadow-sm" data-testid="payment-success-page">
        {paid ? (
          <>
            <div className="w-16 h-16 rounded-full bg-emerald-50 border border-emerald-200 flex items-center justify-center mx-auto">
              <CheckCircle2 className="w-8 h-8 text-emerald-600" />
            </div>
            <h1 className="font-serif text-2xl text-slate-900 mt-5" data-testid="payment-success-title">Payment Received</h1>
            <p className="text-sm text-muted-foreground mt-2">Terima kasih. Bayaran anda telah disahkan.</p>
            <div className="bg-sand rounded-xl p-4 mt-6 text-sm space-y-2" data-testid="payment-success-details">
              <div className="flex justify-between"><span className="text-muted-foreground">Booking</span><span className="font-mono">{status.booking_no}</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Amount</span><span className="font-mono font-semibold text-emerald-700">{fmtRM((status.amount || 0) / 100)}</span></div>
            </div>
            <Link to="/app/portal" data-testid="back-to-portal-link"
              className="inline-block mt-6 px-6 py-2.5 rounded-full bg-emerald-800 hover:bg-emerald-700 text-white text-sm font-semibold transition-colors">
              Back to Portal
            </Link>
          </>
        ) : (
          <>
            <Loader2 className="w-10 h-10 text-gold-600 animate-spin mx-auto" />
            <h1 className="font-serif text-2xl text-slate-900 mt-5">Confirming Payment…</h1>
            <p className="text-sm text-muted-foreground mt-2">Sila tunggu sebentar / Please wait a moment.</p>
          </>
        )}
      </div>
    </div>
  );
}
